import { AFGEROND_SET } from '../../../utils/taakStatus';
// Color schemes
const typeColors = {
  'Video': '#3b82f6',
  'Testimonial': '#ec4899',
  'Interview': '#10b981',
  'Animatiefilm': '#ef4444',
  'Registratie': '#f59e0b',
  'Campagne': '#10b981',
  'Podcast': '#06b6d4',
};


const statusColors = {
  'In progress': { bg: '#dbeafe', text: '#1d4ed8' },
  'Afgerond': { bg: '#dcfce7', text: '#166534' },
  'On hold': { bg: '#fef3c7', text: '#b45309' },
  'Nog niet gestart': { bg: '#f3f4f6', text: '#6b7280' },
  // Deliverable-statussen (Airtable singleSelect op tbl27rzAU3Aoj86pn)
  'Wachten op interne feedback': { bg: '#fef3c7', text: '#b45309' },
  'Feedback ontvangen klant': { bg: '#ffedd5', text: '#c2410c' },
  'Feedback verwerken': { bg: '#ede9fe', text: '#6d28d9' },
  'Opgeleverd': { bg: '#dcfce7', text: '#166534' },
};


/** Formaat is multipleSelects: normaliseer legacy strings naar een array. */
const toFormaatArray = (raw) => {
  if (Array.isArray(raw)) return raw;
  if (!raw) return [];
  return String(raw).split(',').map(s => s.trim()).filter(Boolean);
};


const formatFormaat = (raw) => toFormaatArray(raw).join(', ');


const taskTypeColors = {
  'Preproductie': '#818cf8',
  'Draaidag': '#f59e0b',
  'Montage': '#10b981',
  'Animatie': '#ec4899',
  'Deadline': '#ef4444',
  'IT': '#6366f1',
  'Archief': '#6b7280',
  'Afspraak': '#06b6d4',
  'Script': '#8b5cf6',
  'Grading': '#f97316',
  'Audio': '#14b8a6',
  'Regie': '#7c3aed',
  'Illustratie': '#db2777',
  'Projectafronding': '#059669',
  'Compliance': '#0891b2',
  'Marketing': '#ea580c',
  'Social Strategie': '#4f46e5',
};


// Production phases configuration
const productionPhases = [
  {
    name: 'Concepting & Strategie',
    icon: '\u{1F4A1}',
    color: '#7c3aed',
    types: ['Social Strategie', 'Marketing'],
  },
  {
    name: 'Preproductie',
    icon: '\u{1F4CB}',
    color: '#818cf8',
    types: ['Preproductie'],
  },
  {
    name: 'Productie',
    icon: '\u{1F3AC}',
    color: '#f59e0b',
    types: ['Draaidag'],
  },
  {
    name: 'Postproductie',
    icon: '\u{1F39E}\uFE0F',
    color: '#10b981',
    types: ['Montage', 'Animatie', 'Illustratie', 'Grading', 'Audio', 'Regie'], // Regie = creative reviews
  },
  {
    name: 'Afronding',
    icon: '\u2705',
    color: '#059669',
    types: ['Projectafronding', 'Archief', 'Compliance', 'Deadline'],
  },
  {
    name: 'Overig',
    icon: '\u{1F4CC}',
    color: '#6b7280',
    types: ['Vrije dag', 'Intern', 'IT', 'Reparatie', 'Afspraak'],
  },
];


// Get phase for a task type
const getPhaseForType = (type) => {
  if (!type) return productionPhases.find(p => p.name === 'Overig');
  const phase = productionPhases.find(p => p.types.includes(type));
  return phase || productionPhases.find(p => p.name === 'Overig');
};


// Helpers
const formatDate = (dateStr) => {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' });
};


const getInitials = (name) => {
  if (!name) return '?';
  const parts = name.split(' ');
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  return name.substring(0, 2).toUpperCase();
};


const stringToColor = (str) => {
  if (!str) return '#6b7280';
  let hash = 0;
  for (let i = 0; i < str.length; i++) hash = str.charCodeAt(i) + ((hash << 5) - hash);
  const colors = ['#3b82f6', '#8b5cf6', '#ec4899', '#f59e0b', '#10b981', '#06b6d4', '#6366f1', '#ef4444'];
  return colors[Math.abs(hash) % colors.length];
};

export {
  typeColors,
  statusColors,
  toFormaatArray,
  formatFormaat,
  taskTypeColors,
  productionPhases,
  getPhaseForType,
  formatDate,
  getInitials,
  stringToColor,
};

// Eén definitie van "klaar" voor het projectoverzicht (FU-09, 5 sep 2026). In Airtable
// zetten PL's meestal alleen de status (Opgestuurd/Afgerond/Gearchiveerd) zonder het
// Afgerond-vinkje; de tellers en vinkjes negeerden dat en toonden "0 van 9 afgerond"
// naast negen groene statuspillen.
export const AFGERONDE_STATUSSEN = AFGEROND_SET; // één bron: utils/taakStatus
export const isTaakAfgerond = (task) => {
  const f = task?.fields || task || {};
  return f.Afgerond === true || AFGERONDE_STATUSSEN.has(f.PrioNr) || AFGERONDE_STATUSSEN.has(f.Status);
};
